import { gql } from '@apollo/client';

export default gql`
  query subscriptionProducts {
    subscriptionProducts {
      id
      price
      showInStore
      overPrice
      productId
      product {
        id
        name
        arches
        isRetainer
        isEot
        description
        price
        defaultSubscriptionRetainer
        featuredImage
        productType
        renewalIntervalMonths
        productFeatures {
          id
          text
        }
      }
    }
  }
`;
